import {useState, useEffect, useRef} from 'react'
import AdminNavBar from './AdminNavBar'
import ReportNavBar from './ReportNavBar'
import LocationReport from './LocationReport'

const PaidEntriesByLocation = () => {
	interface Location {
		id: number;
		short_name: string;
		long_name: string;
	}

	var locationRef = useRef<HTMLSelectElement>(null)

	const [locations, setLocations] = useState<Location[]>([])
	const [selectedLocation, setSelectedLocation] = useState<Location>({ id: 0, short_name: "", long_name: "" })
	var startDateRef = useRef<HTMLInputElement>(null)
	var endDateRef = useRef<HTMLInputElement>(null)
	const [isStartDateSet, setStartDateSet] = useState(false)
	const [isEndDateSet, setEndDateSet] = useState(false)
	const [locationShortName, setLocationShortName] = useState("")
	const [locationLongName, setLocationLongName] = useState("")
	const [isVisible, setIsVisible] = useState(false)
	const [key, setKey] = useState("")

	useEffect(() => {
		getLocations()
		if (selectedLocation && selectedLocation.id && selectedLocation.id > 0){
			setLocationShortName(selectedLocation.short_name)
			setLocationLongName(selectedLocation.long_name)
		}
	}, [selectedLocation])

	const handleSelectChange = async () => {
		if (locationRef && locationRef.current) {
			const id = locationRef.current.value;
			const response = await fetch(process.env.REACT_APP_API+"/api/locationByID?id=" + id);
			const location = await response.json()
			setSelectedLocation(location)
			setLocationShortName(location.short_name)
			setLocationLongName(location.long_name)
			setIsVisible(true)
		}
	}

	function CheckStartDateSet(): boolean {
		if (startDateRef && startDateRef.current && startDateRef.current.value !== "") {
			return true;
		} else {
			return false;
		}
	}

	function CheckEndDateSet(): boolean {
		if (endDateRef && endDateRef.current && endDateRef.current.value !== "") {
			return true;
		} else {
			return false;
		}
	}

	const EndDateChange = () => {
		if (CheckEndDateSet()) {
			setEndDateSet(true)
		} else {
			setEndDateSet(false)
		}
		if(startDateRef.current && endDateRef.current) {
			setKey(startDateRef.current?.value + endDateRef.current?.value)
		}
	}

	const StartDateChange = () => {
		if (CheckStartDateSet()) {
			setStartDateSet(true)
		}
		else {
			setStartDateSet(false)
		}
		if(startDateRef.current && endDateRef.current) {
			setKey(startDateRef.current?.value + endDateRef.current?.value)
		}
	}

	const clearEntries = () => {
		setStartDateSet(false)
		setEndDateSet(false)
		if (startDateRef && startDateRef.current) {
			startDateRef.current.value = ""
		}
		if (endDateRef && endDateRef.current) {
			endDateRef.current.value = ""
		}
	}

	const getLocations = async () => {
		const response = await fetch(process.env.REACT_APP_API+"/api/locations")
		if (response) {
			const locations = await response.json()
			setLocations(locations)
		}
	}

	return (
		<div className="resilire">
			<AdminNavBar />
			<ReportNavBar />
			<label>Timesheet by Location</label>
			<label htmlFor="location">Location</label>
			<select id="location" onChange={handleSelectChange} ref={locationRef}>
				<option value=""></option>
				{locations.map((location) => (
					<option value={location.id} key={location.id}>{location.long_name}</option>
				))}
			</select>
			<label htmlFor="start_date">Start Date</label>
			<input type="date" id="start_date" name="start_date" ref={startDateRef} onChange={() => StartDateChange() } />
			<label htmlFor="end_date">End Date</label>
			<input type="date" id="end_date" name="end_date" ref={endDateRef} onChange={() => EndDateChange()} />
			{
				isStartDateSet && isEndDateSet && isVisible && (<LocationReport key={key} id={selectedLocation.id} startDateRef={startDateRef} endDateRef={endDateRef} />)
			}

		</div>
	)
};

export default PaidEntriesByLocation;
